import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SidebarLayoutNavItem, {
  SidebarLayoutNavItemProps,
  SidebarLayoutNavRoot,
} from "@/components/atoms/SidebarLayout";

const reportsNavigation: SidebarLayoutNavItemProps[] = [
  {
    href: `/reports?dashboardKey=sales`,
    text: "navigation:salesReports",
    icon: "arrowSalesBlackMD",
  },
  {
    href: `/reports?dashboardKey=esg`,
    text: "navigation:esg",
    icon: "leaf-bar-chart",
  },
  {
    href: `/reports?dashboardKey=buy`,
    text: "navigation:purchaseReports",
    icon: "arrowPurchaseBlackMD",
  },
];

const SettingsNavigation: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <SidebarLayoutNavRoot>
      {reportsNavigation.map((item: SidebarLayoutNavItemProps, i) => (
        <SidebarLayoutNavItem
          href={item.href}
          text={t(item.text)}
          isActive={location.pathname + location.search === item.href}
          icon={item.icon}
          key={i}
        />
      ))}
    </SidebarLayoutNavRoot>
  );
};

export default SettingsNavigation;
